import { Injectable } from '@angular/core';
import { HttpClient } from './webservice/http-client.service';
import { OauthHelper } from './webservice/oauth-helper.service';


@Injectable()
export class ImpersonatorService {
	private tokenUrl = '/auth/tokens';
	private SEPERATOR = "#_#_#_#_#";
	constructor(private httpClient: HttpClient,
		private oauthHelper: OauthHelper,
	) {
	}

	public impersonate(username: string, authorities: string[], merchantId: string, bookingOfficeUUID: string) {
		let queryString = "?";
		if (username) {
			queryString += `username=${username}&`;
		}
		if (bookingOfficeUUID) {
			queryString += `bookingOfficeUUID=${bookingOfficeUUID}&`;
		}
		queryString += `merchantId=${merchantId}&`;
		for (const role of authorities) {
			queryString += `authorities=${role}&`;
		}

		this.httpClient.get(this.tokenUrl + queryString)
			.map(response => response.json())
			.subscribe(json => {
				const originalToken = this.oauthHelper.getAccessToken();
				let storedTokens = localStorage.getItem("stored_tokens");
				if (!storedTokens) {
					storedTokens = originalToken
				} else {
					storedTokens += this.SEPERATOR + originalToken
				}
				localStorage.setItem("stored_tokens", storedTokens);
				localStorage.setItem("impersonated", "true");
				const impersonateToken = json.access_token;
				this.oauthHelper.storeAccessToken(impersonateToken);
				location.reload();
			});
	}

	public removeImpersonate() {
		let storedTokens = localStorage.getItem("stored_tokens");
		let tokens = storedTokens.split(this.SEPERATOR);
		const lastToken = tokens.splice(tokens.length - 1, 1)[0];
		if (tokens.length === 0) {
			localStorage.removeItem("impersonated");
			localStorage.removeItem("stored_tokens");
		} else {
			localStorage.setItem("stored_tokens", tokens.join(this.SEPERATOR));
		}
		this.oauthHelper.storeAccessToken(lastToken);
		location.reload();
	}



	public isImpersonated() {
		return "true" === localStorage.getItem("impersonated");
	}
}



// WEBPACK FOOTER //
// ./src/app/services/impersonator.service.ts